import { App, Button, Card, Col, Form, Input, InputNumber, Row, Select, Space, Table, Upload, Modal } from 'antd';
import CourseCardView from './courseCardView'; // Adjust the path as needed
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { DELETE, GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';
import LayoutHeader from '../../adminnavigation/layoutHeader';
import AWS from 'aws-sdk';
import { UploadOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
function IndexCourse() {
    interface AwsData {
        accessKeyId?: string;
        secretAccessKey?: string;
        region?: string;
        [key: string]: any;
    }
    const [awsData, setawsData] = useState<AwsData>({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const [allCategoryData, setallCategoryData] = useState<any>([]);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const [CourseFilterData, setCourseFilterData] = useState<any>([]);
    const fetchawsDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
            if (response && response.accessKeyId) {
                setawsData(response); // Not response.data
            } else if (response?.data?.accessKeyId) {
                setawsData(response.data); // If using Axios-style
            } else {
                console.warn("AWS credentials not found in response", response);
            }
        } catch (error) {
            console.error("Failed to fetch AWS credentials", error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
            AWS.config.update({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region,
            });
        }
    }, [awsData]);
    useEffect(() => {
        fetchawsDetails();
    }, []);
    // State for file URLs
    const [fileUrls, setFileUrls] = useState({
        course_image: null,
        course_certificate_image: null,
        course_Brousher: null,
        course_logo1: null,
        course_logo2: null,
        course_logo3: null,
        course_logo4: null
    });
    const S3_BUCKET = awsData?.bucketName;
    const handleFileUpload = (file: any, folder: string, fieldName: string) => {
        return new Promise((resolve, reject) => {
            const timestamp = Date.now();
            const fileName = file.name.replace(/\s+/g, "-");
            const key = `${folder}/${timestamp}_${fileName}`;

            const s3 = new AWS.S3({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region
            });

            const params = {
                Bucket: S3_BUCKET, // Use from response instead of hardcoded
                Key: key,
                Body: file,
                ContentType: file.type,
            };

            s3.upload(params, (err: any, data: any) => {
                if (err) {
                    console.error("S3 Upload Error:", err);
                    notification.error({
                        message: `${fieldName} upload failed!`,
                        description: `Error: ${err.message || "Unknown error"}`,
                    });
                    reject(err);
                } else {
                    const fileUrl = data.Location;

                    const newFileUrls: any = { ...fileUrls };
                    newFileUrls[fieldName] = fileUrl;
                    setFileUrls(newFileUrls);

                    form.setFieldValue(fieldName, fileUrl);
                    notification.success({ message: `${fieldName} uploaded successfully!` });
                    resolve({ ...data, Location: fileUrl });
                }
            });
        });
    };


    // Create upload props for each file type
    const createUploadProps = (folder: any, fieldName: any, accept = "image/*") => {
        return {
            name: "file",
            accept,

            multiple: false,
            showUploadList: false,
            customRequest: async (options: any) => {
                const { onSuccess, onError, file } = options;
                try {
                    setIsLoading(true);
                    const data = await handleFileUpload(file, folder, fieldName);
                    onSuccess(data);
                } catch (error) {
                    onError(error);
                } finally {
                    setIsLoading(false);
                }
            },
            onChange: (info: any) => {
                if (info.file.status === "done") {
                    notification.success({ message: `${fieldName} upload successful!` });
                } else if (info.file.status === "error") {
                    notification.error({ message: `${fieldName} upload failed!` });
                }
            },
        };
    };

    const uploadProps = {
        course_image: createUploadProps("images", "course_image"),
        course_certificate_image: createUploadProps("certificates", "course_certificate_image", ".pdf,.jpg,.jpeg,.png"),
        course_Brousher: createUploadProps("brochures", "course_Brousher", ".pdf,.jpg,.jpeg,.png"),
        course_logo1: createUploadProps("logos", "course_logo1"),
        course_logo2: createUploadProps("logos", "course_logo2"),
        course_logo3: createUploadProps("logos", "course_logo3"),
        course_logo4: createUploadProps("logos", "course_logo4"),
    };

    const submitHandler = async (values: any) => {
        try {
            // Extracting strings from the arrays of objects
            let course_description = values.course_description.map((item: any) => item.description);
            let targetAudiance = values.targetAudiance.map((item: any) => item.audience);

            let obj = {
                course_title: values.course_title,
                subcourse_title: values.subcourse_title,
                course_price: values.course_price,
                category_id: Number(values.category_id),
                course_certificate_image: values.course_certificate_image,
                course_image: values.course_image,
                course_Brousher: values.course_Brousher,
                course_logo1: values.course_logo1,
                course_logo2: values.course_logo2,
                course_logo3: values.course_logo3,
                course_logo4: values.course_logo4,
                course_duration: values.course_duration,
                course_description: course_description,
                targetAudiance: targetAudiance,
            };

            setIsLoading(true);
            const postRequest = await POST(API.CREATE_COURSE, obj);

            if (postRequest) {
                notification.success({ message: "Course created successfully!" });
                form.resetFields();
                fetchAllCourse();
                window.location.reload();
                setFileUrls({
                    course_image: null,
                    course_certificate_image: null,
                    course_Brousher: null,
                    course_logo1: null,
                    course_logo2: null,
                    course_logo3: null,
                    course_logo4: null
                });
                setIsModalOpen(false);

            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetachALLCategory = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});
            setallCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetachALLCategory();
        fetchAllCourse();

    }, []);



    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE;
            const response: any = await POST(api, values);

            if (response?.data) {
                setCourseFilterData(response?.data);
            } else {
                console.error("Data not available:", response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Helper function to display file preview
    const renderFilePreview = (url: string | null, type: string) => {
        if (!url) return null;

        if (url.toLowerCase().endsWith(".pdf")) {
            return (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block mt-2 text-blue-600 underline"
                >
                    View Uploaded PDF
                </a>
            );
        } else {
            return (
                <img
                    src={url}
                    alt={type}
                    style={{ width: "50px", height: "50px", marginTop: "8px" }}
                />
            );
        }
    };


    const handleOk = () => {
        form.submit();
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };
    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold mb-4 text-center" style={{ textAlign: "center" }}>Course Management</h1>

            <Modal
                title="Create New Course"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Create"
                confirmLoading={isLoading}
                width={1000}
            >
                <Card className="shadow-md rounded-lg">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={submitHandler}
                        className="space-y-4"
                    >
                        <Row gutter={16}>
                            {/* Course Title */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Course Title"
                                    name="course_title"
                                    rules={[{ required: true, message: 'Please input the course title!' }]}
                                >
                                    <Input placeholder="Enter course title" />
                                </Form.Item>
                            </Col>

                            {/* Course Sub Title */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Course Sub Title"
                                    name="subcourse_title"
                                    rules={[{ required: true, message: 'Please input the course Sub title!' }]}
                                >
                                    <Input placeholder="Enter course Sub title" />
                                </Form.Item>
                            </Col>

                            {/* Course Price */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Course Price"
                                    name="course_price"
                                // rules={[{ required: true, message: 'Please input the course price!' }]}
                                >
                                    <InputNumber
                                        placeholder="Enter course price"
                                        min={0}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </Col>

                            {/* Category */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Category"
                                    name="category_id"
                                    rules={[{ required: true, message: 'Please select a category!' }]}
                                >
                                    <Select
                                        placeholder="Select a category"
                                        loading={isLoading}
                                        notFoundContent="No categories found"
                                    >
                                        {allCategoryData.map((category: any) => (
                                            <Select.Option key={category.id} value={category.id}>
                                                {category.categoryTitle}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            {/* Course Duration */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Course Duration"
                                    name="course_duration"
                                    rules={[{ required: true, message: 'Please input the course duration!' }]}
                                >
                                    <Input placeholder="Enter course duration (e.g., 6 weeks)" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            {/* Course Image */}
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item
                                    label="Course Image"
                                    name="course_image"
                                    rules={[{ required: true, message: "Please upload the course image!" }]}
                                >
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_image}>
                                            <Button icon={<UploadOutlined />}>Upload Course Image</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_image, "Course")}
                                    </div>
                                </Form.Item>
                            </Col>

                            {/* Certificate */}
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item
                                    label="Course Certificate (PDF or Image)"
                                    name="course_certificate_image"
                                >
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_certificate_image}>
                                            <Button icon={<UploadOutlined />}>Upload Certificate</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_certificate_image, "Certificate")}
                                    </div>
                                </Form.Item>
                            </Col>

                            {/* Brochure */}
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item
                                    label="Course Brochure (PDF or Image)"
                                    name="course_Brousher"
                                >
                                    <div className="flex items-center space-x-4">
                                        <Upload {...uploadProps.course_Brousher}>
                                            <Button icon={<UploadOutlined />}>Upload Brochure</Button>
                                        </Upload>
                                        {renderFilePreview(fileUrls.course_Brousher, "Brochure")}
                                    </div>
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Logos */}
                        <Card title="Partner Logos" className="mb-4">
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Logo 1" name="course_logo1">
                                        <div className="flex items-center space-x-4">
                                            <Upload {...uploadProps.course_logo1}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                            {renderFilePreview(fileUrls.course_logo1, "Logo 1")}
                                        </div>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Logo 2" name="course_logo2">
                                        <div className="flex items-center space-x-4">
                                            <Upload {...uploadProps.course_logo2}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                            {renderFilePreview(fileUrls.course_logo2, "Logo 2")}
                                        </div>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Logo 3" name="course_logo3">
                                        <div className="flex items-center space-x-4">
                                            <Upload {...uploadProps.course_logo3}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                            {renderFilePreview(fileUrls.course_logo3, "Logo 3")}
                                        </div>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item label="Logo 4" name="course_logo4">
                                        <div className="flex items-center space-x-4">
                                            <Upload {...uploadProps.course_logo4}>
                                                <Button icon={<UploadOutlined />}>Upload</Button>
                                            </Upload>
                                            {renderFilePreview(fileUrls.course_logo4, "Logo 4")}
                                        </div>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        <Row gutter={16}>
                            {/* Course Description (Array) */}
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Course Description"
                                    name="course_description"
                                    rules={[{ required: true, message: 'Please input at least one description!' }]}
                                >
                                    <Form.List
                                        name="course_description"
                                        rules={[
                                            {
                                                validator: async (_, names) => {
                                                    if (!names || names.length < 1) {
                                                        return Promise.reject(new Error('At least one description is required'));
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map(({ key, name, ...restField }) => (
                                                    <Space key={key} className="flex items-center mb-2" align="baseline">
                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, 'description']}
                                                            rules={[{ required: true, message: 'Required' }]}
                                                            className="mb-0 flex-grow"
                                                        >
                                                            <Input placeholder="Enter description" />
                                                        </Form.Item>
                                                        <Button
                                                            onClick={() => remove(name)}
                                                            icon={<MinusOutlined />}
                                                            danger
                                                        />
                                                    </Space>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => add()}
                                                        block
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Add Description
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Col>

                            {/* Target Audience (Array) */}
                            <Col xs={24} md={12}>
                                <Form.Item label="Target Audience" name="targetAudiance">
                                    <Form.List name="targetAudiance">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map(({ key, name, ...restField }) => (
                                                    <Space key={key} className="flex items-center mb-2" align="baseline">
                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, 'audience']}
                                                            className="mb-0 flex-grow"
                                                        >
                                                            <Input placeholder="Enter target audience" />
                                                        </Form.Item>
                                                        <Button
                                                            onClick={() => remove(name)}
                                                            icon={<MinusOutlined />}
                                                            danger
                                                        />
                                                    </Space>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => add()}
                                                        block
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Add Target Audience
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Col>
                        </Row>


                    </Form>
                </Card>
            </Modal>
            <Card>
                <h2 className="text-center mt-4">Course List</h2>
                <Card className="mb-4">
                    <Form
                        form={form1}
                        layout="inline"
                        onFinish={filterCourseData}
                        style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                        <Form.Item name="course_title">
                            <Select
                                placeholder="Select Course"
                                allowClear
                                style={{ width: "200px" }}
                                options={allCourseData?.map((item: any) => ({
                                    value: item.course_title,
                                    label: item.course_title,
                                }))}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Filter
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    form1.resetFields();
                                    setCourseFilterData([]);
                                    fetchAllCourse();
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Item>
                        <Button type="primary" onClick={() => setIsModalOpen(true)}>
                            Add Course
                        </Button>
                    </Form>

                </Card>
                <CourseCardView
                    allCourseData={allCourseData}
                    CourseFilterData={CourseFilterData}
                    allCategoryData={allCategoryData}
                    isLoading={isLoading}
                />

            </Card>
        </div>
    );
}

export default IndexCourse;